import React from 'react';

import { I18n } from 'aws-amplify';

import ProjectContainer from '../../containers/project-container';

import FillForm from '../page-templates/fillForm-logged';

import StepsCreative from './steps-creative';
import StepsBidding from './steps-bidding';

import { scrollToTop } from '../../utils/ui';

class ProjectDefintionClientApproved extends React.Component {
    constructor(props) {
        super();
        this.state = {
            task: {}
        };
    }

    submitForm(e) {

    }

    componentDidMount() {

        scrollToTop();
    }

    render() {

        return (
            <FillForm>
                <div className="hero-body has-background-white project-definition-header">
                    <div className="container">
                        <div className="columns is-mobile">
                            <div className="column is-8">
                                <p className="title">{I18n.get("Definições do Projeto")}<br />
                                    <span className="tag is-warning">{this.props.project && this.props.project.projectName}</span>
                                </p>
                            </div>
                            <div className="column is-4">
                                {this.props.isCreative && <>
                                    <StepsCreative active={3} projectId={this.props.match.params.projectId} terms={this.props.clientTermsUpdatedOn} />
                                </>}
                                {this.props.isPartnerSelectionBidding && <>
                                    <StepsBidding active={2} projectId={this.props.match.params.projectId} terms={this.props.clientTermsUpdatedOn} />
                                </>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="client-step client-step-1 project-definition">

                    <div className="container client-container-1">

                        <br /><br /><br />

                        <h1 className="subtitle is-4 is-marginless">{I18n.get("Você declinou a proposta do seu parceiro.")}</h1>
                        <br />
                        <p>{I18n.get("O parceiro será notificado e poderá realizar os ajustes necessários.")}</p>
                        <br />
                    </div>

                </div>

            </FillForm>
        );
    }
}

export default ProjectContainer(ProjectDefintionClientApproved);
